import { useEffect, useState } from 'react';

const THINKING_PHRASES = [
  'Thinking',
  'Analysing your data',
  'Crunching numbers',
  'Preparing insights',
  'Looking for patterns',
  ];

export const ThinkingBubble = () => {
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPhraseIndex((i) => (i + 1) % THINKING_PHRASES.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex justify-start">
      <div className="bg-card border rounded-2xl rounded-bl-sm px-4 py-3 text-sm">
        <div className="flex items-center gap-2.5">
          <div className="flex items-center gap-1">
            <span
              className="size-1.5 rounded-full bg-muted-foreground/60 animate-bounce"
              style={{ animationDelay: '0ms' }}
            />
            <span
              className="size-1.5 rounded-full bg-muted-foreground/60 animate-bounce"
              style={{ animationDelay: '150ms' }}
            />
            <span
              className="size-1.5 rounded-full bg-muted-foreground/60 animate-bounce"
              style={{ animationDelay: '300ms' }}
            />
          </div>
          <span
            key={phraseIndex}
            className="text-muted-foreground text-xs animate-in fade-in duration-500"
          >
            {THINKING_PHRASES[phraseIndex]}
          </span>
        </div>
      </div>
    </div>
  );
};
